/* @ts-nocheck */
/* eslint-disable */
(function () {
  function playVideoBlock(poster) {
    var media = poster.closest('.c21-video-block__media');
    if (!media) return;

    var videoWrap = media.querySelector('.c21-video-block__video');
    var template = media.querySelector('.c21-video-block__video-template');
    var block = poster.closest('.c21-video-block');

    if (template && videoWrap && !videoWrap.dataset.loaded) {
      videoWrap.appendChild(template.content.cloneNode(true));
      videoWrap.dataset.loaded = 'true';

      var videoEl = videoWrap.querySelector('.video-div');
      if (videoEl && block) {
        var markLoaded = function () {
          block.classList.add('is-loaded');
        };
        var loadEvent = videoEl.tagName === 'VIDEO' ? 'loadeddata' : 'load';
        videoEl.addEventListener(loadEvent, markLoaded, { once: true });
      }
    }

    if (block) block.classList.add('is-playing');
  }

  document.addEventListener('click', function (evt) {
    var poster = evt.target.closest('.c21-video-block__poster');
    if (poster) {
      playVideoBlock(poster);
      return;
    }

    var btn = evt.target.closest('.c21-video-block__btn');
    if (btn) {
      var block = btn.closest('.c21-video-block');
      var blockPoster = block && block.querySelector('.c21-video-block__poster');
      if (blockPoster) blockPoster.click();
    }
  });
})();
